import React, { useState } from 'react';
import cutomerstoriesrightsigeimage from '../assets/cutomerstoriesrightsigeimage.png';
import img1 from '../assets/testimonial/image1.png';
import img2 from '../assets/testimonial/image2.png';
import img3 from '../assets/testimonial/image3.png';


// const BlurGlowSVG: React.FC = () => (
//   <svg 
//     width="337" 
//     height="471" 
//     viewBox="0 0 337 471" 
//     fill="none" 
//     xmlns="http://www.w3.org/2000/svg" 
//     className="pointer-events-none select-none"
//   >
//     <g filter="url(#filter0_f_48_562)">
//       <path d="M128 151C128 44.9613 213.961 -41 320 -41C426.039 -41 512 44.9613 512 151C512 257.039 426.039 343 320 343C213.961 343 128 257.039 128 151Z" fill="#E53935" fillOpacity="0.05"/>
//     </g>
//     <defs>
//       <filter id="filter0_f_48_562" x="0" y="-169" width="640" height="640" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
//         <feFlood floodOpacity="0" result="BackgroundImageFix"/>
//         <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
//         <feGaussianBlur stdDeviation="64" result="effect1_foregroundBlur_48_562"/>
//       </filter>
//     </defs>
//   </svg>
// );

const BackgroundArchesSVG: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="620" 
    height="640" 
    viewBox="0 0 620 640" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M42.9719 56.8909C59.4651 57.7433 75.6375 52.0962 87.9796 41.1716C103.622 25.5887 111.974 10.5511 113.568 -4.85015C114.696 -11.7995 114.155 -18.9161 111.993 -25.6188C109.839 -32.3212 106.111 -38.4194 101.133 -43.4148C96.1549 -48.4103 90.0584 -52.1613 83.3467 -54.3614C76.635 -56.5615 69.4944 -57.1484 62.5124 -56.0738C28.0141 -52.78 -1.05793 -20.0013 0.173483 13.9357C0.360852 25.2152 4.92021 35.9855 12.8969 43.992C20.8745 51.9988 31.6515 56.6207 42.9719 56.8909Z" fill="#AD1815" fillOpacity="0.05"/>
    <path d="M5.50959 195.251V193.434C5.5012 189.49 5.49003 185.518 5.47978 181.528C5.43224 163.733 5.38286 145.559 5.53201 127.672C5.62336 120.131 7.17355 114.861 10.3886 111.658C13.6037 108.455 18.6431 106.932 25.9393 106.524C105.197 102.208 159.236 48.3269 163.683 -30.7006C164.484 -45.4884 170.068 -50.7812 185.03 -50.9175C207.738 -51.1446 230.968 -51.0765 252.837 -50.9629C262.093 -50.8266 268.479 -49.0094 271.834 -45.6702C275.181 -42.331 276.645 -36.3341 276.393 -27.4977C274.342 38.8316 249.145 97.0515 201.576 145.572C153.717 191.662 96.034 216.377 30.3402 218.671C20.7182 219.034 14.3794 217.444 10.8221 214.173C7.26493 210.902 5.55527 204.701 5.50959 195.251Z" fill="#AD1815" fillOpacity="0.05"/>
    <path d="M595.861 393.535C601.473 395.443 603.822 397.783 604.12 399.26C604.391 400.577 603.3 403.393 599.31 407.051C595.367 409.481 591.21 411.889 586.996 414.32C576.425 420.216 566.218 426.732 556.421 433.833C478.891 492.711 437.8 571.534 434.407 668.098C433.792 685.611 428.273 690.973 410.758 691.018H406.199C385.859 691.064 364.838 691.109 344.181 690.973C335.717 690.905 329.471 688.86 326.208 685.475C322.955 682.091 321.426 676.525 321.678 668.916C325.556 555.383 366.46 459.251 443.505 382.495C454.281 371.758 465.756 361.416 477.931 351.466C484.316 346.242 487.812 345.946 494.971 349.989C527.141 367.662 560.923 382.243 595.861 393.535Z" fill="#AD1815" fillOpacity="0.05"/>
    <path d="M480.232 301.278L485.621 306.357C496.439 316.982 507.789 327.047 519.646 336.51C608.314 402.6 708.634 430.789 817.83 420.346C826.247 419.513 831.817 417.314 834.862 413.527L834.984 413.375C838.003 409.524 838.975 403.475 837.963 394.902L837.906 394.292C835.259 372.097 832.459 349.051 829.552 326.659C827.653 312.955 820.515 307.405 806.455 308.706C716.231 317.47 636.576 291.191 569.613 230.638C553.577 215.783 539.193 199.25 526.712 181.325C521.796 174.448 519.182 173.512 515.974 174.16C512.767 174.808 512.256 176.45 510.635 184.318C503.186 221.113 492.423 257.167 478.471 292.043C476.534 296.814 477.218 298.4 480.232 301.278Z" fill="#AD1815" fillOpacity="0.05"/>
    <path d="M27.535 264.216C156.999 268.531 263.967 320.573 345.458 418.841C351.387 426.019 351.75 429.925 347.285 437.739C330.245 468.258 316.216 500.346 305.374 533.554L304.573 536.03C301.953 544.184 300.881 545.116 297.898 545.321C293.47 545.684 291.559 543.276 286.926 534.622C272.878 508.362 254.934 484.363 233.708 463.431C177.162 408.232 108.572 378.974 29.8384 376.498C10.4798 375.885 5.48609 370.82 5.48609 351.784L5.46276 335.315C5.41802 319.126 5.4255 302.931 5.48609 286.727C5.53177 278.413 7.33274 272.393 10.8443 268.895L11.027 268.713C14.4238 265.465 19.9648 263.943 27.535 264.216Z" fill="#AD1815" fillOpacity="0.05"/>
    <path d="M750.417 461.818C750.389 454.579 750.38 447.333 750.389 440.079C750.501 437.46 750.072 434.845 749.121 432.402C748.161 429.959 746.707 427.738 744.852 425.883C741.161 422.475 736.145 420.93 728.39 421.067C664.544 421.067 600.839 448.462 553.754 495.369C506.549 542.391 479.459 605.722 479.599 669.189C479.581 684.931 485.509 690.837 501.422 690.928C525.481 691.132 549.149 691.086 571.764 690.859C585.672 690.632 591.508 685.18 592.328 671.143C596.98 591.274 650.021 538.484 730.692 533.305C744.255 532.463 750.165 526.671 750.259 513.814C750.464 496.664 750.548 479.082 750.417 461.818Z" fill="#AD1815" fillOpacity="0.05"/>
    <path d="M479.534 -27.793C481.333 29.1095 499.529 79.4923 533.526 121.857C583.64 184.279 649.835 216.922 730.301 218.898C732.985 219.358 735.745 219.181 738.346 218.38C740.956 217.58 743.333 216.179 745.29 214.29C747.248 212.403 748.73 210.081 749.616 207.515C750.501 204.949 750.771 202.21 750.389 199.522C750.734 174.012 750.734 149.207 750.371 125.719C750.166 113.157 744.209 107.001 732.081 106.91C694.934 106.588 659.399 91.7018 633.186 65.475C606.973 39.2476 592.179 3.79004 592.011 -33.222C592.011 -47.442 582.14 -50.6448 573.927 -50.7356C558.676 -51.0183 543.221 -51.0125 527.952 -51.0066H527.942L527.949 -51.0066L527.957 -51.0066C523.59 -51.0048 519.24 -51.0032 514.92 -51.0082L497.087 -50.9174C494.738 -50.9527 492.398 -50.5097 490.226 -49.6153C488.045 -48.7209 486.078 -47.3939 484.437 -45.7156C480.606 -41.6722 479.143 -36.493 479.534 -27.793Z" fill="#AD1815" fillOpacity="0.05"/>
    <path d="M84.3719 693.8C78.1077 695.982 71.4519 696.807 64.8427 696.219C32.7336 694.448 3.22816 666.007 0.377543 634.319C-0.506168 627.4 0.165915 620.372 2.34722 613.743C4.52853 607.116 8.16312 601.054 12.9872 595.999L13.5343 595.453C18.7741 590.623 25.0496 587.045 31.8844 584.991C38.7191 582.936 45.9343 582.459 52.9816 583.596C68.5528 585.572 81.7339 592.568 95.5768 606.357C106.241 617.392 112.654 631.824 113.68 647.108C114.36 653.673 113.615 660.306 111.498 666.558C109.373 672.81 105.924 678.534 101.394 683.339L101.161 683.567C96.3598 688.129 90.6362 691.618 84.3719 693.8Z" fill="#AD1815" fillOpacity="0.05"/>
  </svg>
);

const Testimonials: React.FC = () => {
  const customerStories = [
    {
      id: 1,
      stars: 5,
      text: "The application process was smooth and straightforward. Funds were credited much faster than I expected",
      author: "Ananya Mehta",
      role: "Financial Analyst",
      avatar: img1
    },
    {
      id: 2,
      stars: 5,
      text: "Everything happened online and the support team kept me informed throughout the process",
      author: "Arjun Malhotra",
      role: "Sales Manager",
      avatar: img2
    },
    {
      id: 3,
      stars: 5,
      text: "I needed funds urgently for a family emergency. Dezire Loan made the process incredibly quick and stress-free.",
      author: "Priya Nair",
      role: "HR Consultant",
      avatar: img3
    },
    {
      id: 4,
      stars: 5,
      text: "Outstanding service! The calculator was very clear, and my loan was approved and disbursed on the same day.",
      author: "Karan Sharma",
      role: "Software Engineer",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&h=150&q=80"
    },
    {
      id: 5,
      stars: 5,
      text: "Extremely reliable platform. Minimal paperwork and transparent terms. Will definitely use them again.",
      author: "Neha Gupta",
      role: "Product Manager",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&h=150&q=80"
    }
  ];

  const [startIndex, setStartIndex] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setStartIndex((prev) => (prev + 1) % (customerStories.length - 2)); // cycles 0, 1, 2
  };

  const visibleStories = customerStories.slice(startIndex, startIndex + 3);

  return (
    <section className="w-full bg-[#FFFDFB] pt-12 md:pt-16 pb-12 md:pb-0 px-6 lg:px-20 flex justify-center relative overflow-hidden text-[var(--text-primary)]">
      
      <div className="max-w-[1400px] w-full grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-stretch relative z-10">
        
        {/* Left Column: Heading and Cards Grid */}
        <div className="col-span-1 lg:col-span-8 flex flex-col items-center lg:items-start w-full relative pb-0 md:pb-16">
          
          {/* Header Badge */}
          <div className="hidden md:flex items-center gap-3 text-neutral-500 uppercase tracking-[0.15em] text-xs md:text-sm font-bold mb-3">
            <span className="w-7 h-[1.5px] bg-neutral-400" />
            <span>Customer Stories</span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[50px] font-kualine md:font-sans font-semibold md:font-black leading-[1.15] tracking-tight text-neutral-900 mt-2 text-center lg:text-left">
            Trusted by borrowers
            <span className="block text-[#DE3226] mt-2">across India.</span>
          </h2>

          {/* Cards Grid Container (Desktop Only) */}
          <div className="hidden md:block relative w-full mt-8">
            <div className="grid grid-cols-3 gap-6 items-stretch w-full">
              {visibleStories.map((story) => (
                <div 
                  key={story.id} 
                  className="bg-white border border-[#FBE3DF] rounded-[20px] p-5 md:p-6 flex flex-col justify-between h-full shadow-[0_4px_12px_rgba(222,50,38,0.01)] hover:shadow-md transition-shadow relative"
                >
                  <div>
                    {/* Stars */}
                    <div className="flex items-center gap-0.5 mb-5 text-[#DE3226]">
                      {[...Array(story.stars)].map((_, i) => (
                        <span key={i} className="text-lg">★</span>
                      ))}
                    </div>
                    {/* Story Text */}
                    <p className="text-neutral-600 font-medium text-sm md:text-[14.5px] leading-relaxed">
                      {story.text}
                    </p>
                  </div>

                  {/* Profile Section */}
                  <div>
                    {/* Card Divider */}
                    <div className="w-full h-[1px] bg-neutral-100 mt-4 mb-4" />
                    
                    <div className="flex items-center gap-3.5">
                      <img 
                        src={story.avatar} 
                        alt={story.author} 
                        className="w-11 h-11 rounded-full object-cover border border-neutral-100"
                      />
                      <div className="flex flex-col text-left">
                        <span className="text-neutral-800 font-extrabold text-sm md:text-[15px] leading-tight">
                          {story.author}
                        </span>
                        <span className="text-neutral-400 font-semibold text-[11px] md:text-xs mt-0.5">
                          {story.role}
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
              ))}
            </div>

            {/* Red Circle Navigation Button on Desktop */}
            <div 
              onClick={nextSlide}
              className="hidden md:flex absolute right-[-22px] top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-[#DE3226] hover:bg-[#A82A1B] text-white items-center justify-center shadow-lg active:scale-95 transition-all z-20 cursor-pointer"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </div>

          </div>

          {/* Mobile Carousel: Visible only on mobile */}
          <div className="md:hidden w-full flex flex-col items-center gap-6 mt-8">
            {/* Single Testimonial Card */}
            <div className="w-full bg-white border border-[#FBE3DF] rounded-[24px] p-6 flex flex-col justify-between shadow-[0_4px_12px_rgba(222,50,38,0.01)] hover:shadow-md transition-shadow relative min-h-[220px]">
              <div>
                {/* Stars */}
                <div className="flex items-center gap-0.5 mb-5 text-[#DE3226]">
                  {[...Array(customerStories[currentIndex].stars)].map((_, i) => (
                    <span key={i} className="text-lg">★</span>
                  ))}
                </div>
                {/* Story Text */}
                <p className="text-neutral-600 font-medium text-sm leading-relaxed text-left">
                  {customerStories[currentIndex].text}
                </p>
              </div>

              {/* Profile Section */}
              <div>
                {/* Card Divider */}
                <div className="w-full h-[1px] bg-neutral-100 mt-4 mb-4" />
                
                <div className="flex items-center gap-3.5">
                  <img 
                    src={customerStories[currentIndex].avatar} 
                    alt={customerStories[currentIndex].author} 
                    className="w-11 h-11 rounded-full object-cover border border-neutral-100"
                  />
                  <div className="flex flex-col text-left">
                    <span className="text-neutral-800 font-extrabold text-sm leading-tight">
                      {customerStories[currentIndex].author}
                    </span>
                    <span className="text-neutral-400 font-semibold text-[11px] mt-0.5">
                      {customerStories[currentIndex].role}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Controls */}
            <div className="flex items-center gap-4 mt-2">
              {/* Prev Button */}
              <button 
                onClick={() => setCurrentIndex((prev) => (prev - 1 + customerStories.length) % customerStories.length)}
                className="w-12 h-12 rounded-full border border-neutral-200 bg-white flex items-center justify-center text-neutral-800 hover:bg-neutral-50 active:scale-95 shadow-sm transition-all cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              {/* Next Button */}
              <button 
                onClick={() => setCurrentIndex((prev) => (prev + 1) % customerStories.length)}
                className="w-12 h-12 rounded-full bg-[#DE3226] hover:bg-[#A82A1B] text-white flex items-center justify-center active:scale-95 shadow-md transition-all cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

            {/* Dot Indicators */}
            <div className="flex items-center gap-1.5 mt-2">
              {customerStories.map((_, index) => (
                <span 
                  key={index} 
                  className={`h-1.5 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-6 bg-neutral-900' : 'w-1.5 bg-neutral-300'}`}
                />
              ))}
            </div>
          </div>

        </div>

        {/* Right Column: Family Portrait */}
        <div className="hidden lg:flex col-span-1 lg:col-span-4 w-full justify-center lg:justify-end items-end h-full relative overflow-visible mt-12 lg:mt-0 pb-0">
          {/* Vectors / glow around the image */}
          <div className="absolute inset-0 pointer-events-none select-none z-0 overflow-visible flex items-center justify-center">
            
            {/* Background Arches SVG */}
            <BackgroundArchesSVG className="absolute w-[180%] h-[180%] md:w-[150%] object-contain pointer-events-none select-none z-0 opacity-80" />
            
  
          </div>

          {/* Overflow-hidden crop container for the image */}
          <div className="w-[380px] lg:w-[420px] h-[450px] relative overflow-hidden z-10 flex items-end justify-center">
            <img 
              src={cutomerstoriesrightsigeimage} 
              alt="Trusted family stories" 
              className="absolute bottom-[-110px] left-1/2 -translate-x-1/2 h-[560px] max-w-none object-contain pointer-events-none select-none"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;
